import { RouteUrl } from '@utils/routeUtil';

export interface IMenu {
  title: string;
  url: string;
}

export const RecommendMens: IMenu[] = [
  {
    title: '역검',
    url: RouteUrl.ACCA_TEST_GATE,
  },
  {
    title: '개발자 검사',
    url: RouteUrl.PHS_TEST_GATE,
  },
  {
    title: '기출 면접 연습',
    url: RouteUrl.PASS_INTERVIEW,
  },
];
